import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { RxCross2 } from "react-icons/rx";
import "../Css/AddtoCart.css";
import EmptyComp from "../Component/Empty/empty";
import { useCartContext } from '../context/addToCart';
import { FiMinus, FiPlus } from 'react-icons/fi';

const AddtoCart = () => {
  const { cartValue, setCartCount, setCartValue } = useCartContext();
  const [subTotal, setSubTotal] = useState(0);

  // Calculate subtotal whenever cartValue changes
  useEffect(() => {
    const total = (cartValue || []).reduce((sum, item) => {
      const price = !isNaN(parseFloat(item.product_price)) ? parseFloat(item.product_price) : 0;
      return sum + price * (Number(item.productQuantity) || 0);
    }, 0);
    setSubTotal(total);
  }, [cartValue]);

  // Update cart in state and localStorage
  const updateCart = (newCart) => {
    setCartValue(newCart);
    setCartCount(newCart.length);
    localStorage.setItem("cart", JSON.stringify(newCart));
  };

  const removeCartData = (index) => {
    if (!cartValue) return;
    const updatedData = [...cartValue];
    updatedData.splice(index, 1);
    updateCart(updatedData);
  };

  const changeQuantity = (index, increment) => {
    if (!cartValue) return;
    const updatedData = [...cartValue];
    const item = updatedData[index];
    const price = !isNaN(parseFloat(item.fixedPrice)) ? parseFloat(item.fixedPrice) : 0;
    const newQuantity = Number(item.productQuantity) + increment;
    if (newQuantity < 1) return; // prevent quantity < 1

    item.productQuantity = newQuantity;
    item.productQuantityPrice = (price * newQuantity).toFixed(2);
    updateCart(updatedData);
  };

  return (
    <div className="offcanvas offcanvas-end" tabIndex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
      <div className="offcanvas-header">
        <h5 id="offcanvasRightLabel">Shopping Cart</h5>
        <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
      </div>
      <div className="offcanvas-body">
        {cartValue && cartValue.length > 0 ? (
          // console.log("Shopping Cart",cartValue),
          <>
            <div className='Product-addedCart-Side-Bar'>
              {cartValue.map((elem, index) => (
                <div key={index} className='Product-addedCart-Side-details'>
                  <div className='Product-addedCart-Image-con'>
                    <div className='Product-addedCart-Image'>
                      <img 
                        src={elem?.productImage || '/fallback-image.png'} 
                        alt={elem?.productBrand || 'Product Image'} 
                      />
                    </div>
                  </div>
                  <div className='Product-details-addedCart-price-name'>
  <h2>{elem?.productBrand}</h2>

  {elem.productSize && (
    <h3><span>Size : {elem.productSize}</span></h3>
  )}

  {elem.productThickness && (
    <h3><span>Thickness : {elem.productThickness}</span></h3>
  )}

  <h3><span>Price : </span>{elem.product_price ? `${elem.product_price} ₹` : 'N/A'}</h3>
  
  <div className='Peoduct-Details-Section-1-Quantity-main-con'>
    <div className='Product-details-Quantity-counter-material'>
      <button onClick={() => changeQuantity(index, -1)}><FiMinus /></button>
      <h3>{elem.productQuantity}</h3>
      <button onClick={() => changeQuantity(index, +1)}><FiPlus /></button>
    </div>
  </div>
</div>

                  <div className='Product-details-addedCart-cancel-btn'>
                    <div className='Product-details-addedCart-cancel-btn-con' onClick={() => removeCartData(index)}>
                      <RxCross2 />
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className='Product-details-Addedcart-total-con'>
              <div className='Product-details-Addedcart-total'>
                <div className='Product-details-Addedcart-total-title'>
                  <h4>Subtotal:</h4>
                </div>
                <div className='Product-details-Addedcart-total-Amount'>
                  <h5>{subTotal.toFixed(2)} ₹</h5>
                </div>
              </div>
              <div className='Product-details-Addedcart-btn'>
                <div className='Product-details-Addedcart-btn-ViewCart'>
                  <Link to="/CheckOutPage">
                    <button data-bs-dismiss="offcanvas" aria-label="Close">
                      Checkout
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </>
        ) : (
          <EmptyComp message="Your cart is waiting for some great finds!" />
        )}
      </div>
    </div>
  );
};

export default AddtoCart;
